import { Component } from '@angular/core';

@Component({
    selector: 'app-picture-card-grid',
    templateUrl: './picture-card-grid.component.html',
    styleUrls: ['./picture-card-grid.component.scss'],
    standalone: false
})
export class PictureCardGridComponent {}
